import React from 'react';
import { Switch } from 'react-router-dom';
import Loadable from 'react-loadable';

import Login from 'app/modules/login/login';
import Register from 'app/modules/account/register/register';
import RegisterTokenPage from 'app/modules/account/register/registertoken';
import RegisterSimPage from 'app/modules/account/register/registersim';
import RegisterInfo from 'app/modules/account/register/registerInfo';
import Activate from 'app/modules/account/activate/activate';
import SendOtp from 'app/modules/sendOtp/sendOtp';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import PasswordResetFinish from 'app/modules/account/password-reset/finish/password-reset-finish';
import PasswordResetSendOtp from 'app/modules/account/password-reset/sendOtp';
import PasswordReg from 'app/modules/account/password-reg/password';
import Logout from 'app/modules/login/logout';
import LogOut from 'app/modules/account/user/logout';
import Home from 'app/modules/home/home';
import Entities from 'app/entities';
import PrivateRoute from 'app/shared/auth/private-route';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import PageNotFound from 'app/shared/error/page-not-found';
import UserProfile from 'app/modules/account/user/user-profile';
import { AUTHORITIES } from 'app/config/constants';
import IDPPage from 'app/modules/account/register/idp';
import AdminPage from 'app/shared/layout/menus/adminPage';
import AdminManagerPage from 'app/shared/layout/menus/AdminManager/adminManager';
import RegisterHome from 'app/modules/account/register/registerHome';
import PasswordPage from 'app/modules/account/password-set/password';
import UpdatePhoneNumber from 'app/modules/sendOtp/updatePhoneNumber';
import RegisterAccountORG from './modules/account/register/registerAccountORG';
import RegisterInfoAcc from './modules/account/register/registerInfoAcc';
import SuccessPage from 'app/modules/account/register/successPage';
import resendOption from './modules/sendOtp/resendOption';
import RegisterCcvcInfo from 'app/modules/account/register/ccvc/registerCcvcInfo';

// tslint:disable:space-in-parens
const Account = Loadable({
  loader: () => import(/* webpackChunkName: "account" */ 'app/modules/account'),
  loading: () => <div>loading ...</div>
});

const Admin = Loadable({
  loader: () => import(/* webpackChunkName: "administration" */ 'app/modules/administration'),
  //loader: () => import(/* webpackChunkName: "administration" */ 'app/shared/layout/menus/AdminManager'),
  loading: () => <div>loading ...</div>
});
// tslint:enable

const Routes = () => (
  <div className="view-routes">
    <Switch>
      <ErrorBoundaryRoute path="/login" component={Login} />
      <ErrorBoundaryRoute path="/logout" component={Logout} />
      <ErrorBoundaryRoute path="/removeSession" component={LogOut} />
      <ErrorBoundaryRoute path="/register" exact component={RegisterHome} />
      <ErrorBoundaryRoute path="/registerDVC" exact component={Register} />
      <ErrorBoundaryRoute path="/register/addInfo" exact component={RegisterCcvcInfo} />
      {/* <ErrorBoundaryRoute path="/registerHome" component={RegisterHome} /> */}
      <ErrorBoundaryRoute path="/token/register" component={RegisterTokenPage} />
      <ErrorBoundaryRoute path="/acc/register" component={RegisterAccountORG} />
      <ErrorBoundaryRoute path="/sim/register" component={RegisterSimPage} />
      <ErrorBoundaryRoute path="/info/register" component={RegisterInfo} />
      <ErrorBoundaryRoute path="/info/registeracc" component={RegisterInfoAcc} />
      <ErrorBoundaryRoute path="/sendOtp" component={SendOtp} />
      <ErrorBoundaryRoute path="/resendOtp" component={resendOption} />
      <ErrorBoundaryRoute path="/activate/:key?" component={Activate} />
      <ErrorBoundaryRoute path="/reset/request" component={PasswordResetInit} />
      <ErrorBoundaryRoute path="/reset/sendOtp" component={PasswordResetSendOtp} />
      <ErrorBoundaryRoute path="/reset/finish/:id?" component={PasswordResetFinish} />
      <ErrorBoundaryRoute path="/update/phone" component={UpdatePhoneNumber} />
      {/* <ErrorBoundaryRoute path="/password/:id/:key?" component={PasswordReg} /> */}
      <ErrorBoundaryRoute path="/password" component={PasswordReg} />
      {/* <ErrorBoundaryRoute path="/userprofile" component={UserProfile} /> */}
      <ErrorBoundaryRoute path="/success" component={SuccessPage} />
      <PrivateRoute
        path="/userprofile"
        component={UserProfile}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.USER, AUTHORITIES.MANAGER]}
      />
      <PrivateRoute path="/admin" component={Admin} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANAGER]} />
      <PrivateRoute path="/" exact component={Home} />
      <ErrorBoundaryRoute component={PageNotFound} />
    </Switch>
  </div>
);

export default Routes;
